import type { FC } from 'react';

export type FieldStatusProps = {
  id: string;
  error?: string;
  hint?: string;
};

// biome-ignore lint/style/useComponentExportOnlyModules: describedBy helper shared with the labeled inputs
export const fieldStatusId = ({ id, error, hint }: FieldStatusProps): string | undefined => {
  if (error) return `${id}-error`;
  if (hint) return `${id}-hint`;
  return undefined;
};

export const FieldStatus: FC<FieldStatusProps> = ({ id, error, hint }) => {
  if (error) {
    return (
      <p id={`${id}-error`} className="text-[12px] leading-4 tracking-[-0.12px] text-red-500">
        {error}
      </p>
    );
  }

  if (hint) {
    return (
      <p id={`${id}-hint`} className="text-[12px] leading-4 tracking-[-0.12px] text-black/40">
        {hint}
      </p>
    );
  }

  return null;
};
